<div class="animated fadeIn">
  <h1>Profile</h1>
  @if (isTemporaryRouteChange()){
  <app-empty-message [message]="temporaryRouteChangeMessage()"></app-empty-message>
  }
  <!-- Personal information -->
  <h4 class="my-4 text-body-tertiary fw-bold">Personal information</h4>
  <form action="" [formGroup]="profileForm">
    <div class="row row-gap-3">
      <div class="col-lg-6 col-md-12">
        <div class="form-floating has-validation">
          <input class="form-control" [class.is-invalid]="validateErrors('firstName')" id="firstName" placeholder
            formControlName="firstName">
          <label for="firstName">First name</label>
          <div *ngIf="validateErrors('firstName')" class="invalid-feedback">
            <i class="fas fa-xmark"></i>
            {{validateErrors('firstName')}}
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div class="form-floating has-validation">
          <input class="form-control" [class.is-invalid]="validateErrors('lastName')" id="lastName" placeholder
            formControlName="lastName">
          <label for="lastName">Last name</label>
          <div *ngIf="validateErrors('lastName')" class="invalid-feedback">
            <i class="fas fa-xmark"></i>
            {{validateErrors('lastName')}}
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div class="form-floating has-validation">
          <input class="form-control " [class.is-invalid]="validateErrors('phone')" id="phone" placeholder
            formControlName="phone" (input)="formatPhoneNumber()">
          <label for="phone">Phone</label>
          <div *ngIf="validateErrors('phone')" class="invalid-feedback">
            <i class="fas fa-xmark"></i>
            {{validateErrors('phone')}}
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div class="form-floating has-validation">
          <mat-form-field class="w-100"
            [class.is-invalid]="profileForm.get('birthday')?.hasError('isAtLeast15YearsOld')">
            <mat-label>We love to celebrate birthdays, what’s yours?</mat-label>
            <input matInput formControlName="birthday"
              [class.is-invalid]="profileForm.get('birthday')?.hasError('isAtLeast15YearsOld')"
              [matDatepicker]="birthdayPicker" (dateChange)="onDateChange($event)">
            <mat-hint>MM/DD/YYYY</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="birthdayPicker">
            </mat-datepicker-toggle>
            <mat-datepicker #birthdayPicker></mat-datepicker>
          </mat-form-field>
          <div *ngIf="profileForm.get('birthday')?.hasError('isAtLeast15YearsOld')" class="invalid-feedback">
            <i class="fas fa-xmark"></i>
            {{validateErrors('birthday')}}
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div class="form-floating">
          <input type="email" class="form-control" id="email" placeholder formControlName="email">
          <label for="email">Email</label>
        </div>
        <a href="javascript:void(0)" class="float-end link-primary" (click)="openModalChangeCredentials(true)">Change
          email</a>
      </div>
      <div class="col-lg-6 col-md-12">
        <div class="form-floating">
          <input type="password" class="form-control" id="password" placeholder formControlName="password">
          <label for="password">Password</label>
        </div>
        <a href="javascript:void(0)" class="float-end link-primary" (click)="openModalChangeCredentials()">Reset
          password</a>
      </div>
      <div class="col-lg-6 col-md-12">
        <mat-form-field class="w-100 normalized-mat-control has-validation"
          [class.is-invalid]="validateErrors('howDidYouHear')">
          <mat-label>How did you hear about us?</mat-label>
          <mat-select formControlName="howDidYouHear">
            @for (item of referralSource(); track $index) {
            <mat-option [value]="item.id">{{item.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <div *ngIf="validateErrors('howDidYouHear')" class="invalid-feedback">
          <i class="fas fa-xmark mt-3"></i>
          {{validateErrors('howDidYouHear')}}
        </div>
      </div>
      @if(showAdvertisementField()){
      <div class="col-lg-6 col-md-12 animated fadeIn">
        <div class="form-floating has-validation">
          <input class="form-control" [class.is-invalid]="validateErrors('additionalInfo')" id="advertisement"
            placeholder formControlName="additionalInfo">
          <label for="advertisement">Additional info*</label>
          <div *ngIf="validateErrors('additionalInfo')" class="invalid-feedback">
            <i class="fas fa-xmark"></i>
            {{validateErrors('additionalInfo')}}
          </div>
        </div>
      </div>
      }
    </div>
    <!-- Delivery address -->
    <h4 class="my-4 text-body-tertiary fw-bold">Delivery address</h4>
    <div action="" class="form" formGroupName="address">
      <div class="row row-gap-3">
        <div class="col-lg-6 col-md-12">
          <div class="form-floating has-validation">
            <input #autocompleteInput (ngModelChange)="changeAddress()" class="form-control"
              [class.is-invalid]="!isLoadingContent() && (!hasDeliveryAddressCoverage() && isGoogleAddressFilled())"
              [class.is-valid]="!isLoadingContent() && hasDeliveryAddressCoverage()" id="address" placeholder
              formControlName="street">
            <label for="address">Address</label>
            @if (isLoadingContent()) {
            <mat-progress-bar mode="indeterminate" value="accent"></mat-progress-bar>
            } @else {
            @if (hasDeliveryAddressCoverage()) {
            <div class="valid-tooltip">
              This address is in our delivery area!
            </div>
            } @else if (isGoogleAddressFilled()) {
            <div class="invalid-tooltip">
              Oops! Your address isn't in our delivery zone.
            </div>
            }
            }
          </div>
          @if (!isTemporaryRouteChange()) {
          <a href="javascript:void(0)" class="float-end link-primary" (click)="handleChangeUpdateAddress()">
            {{isUpdatingAddress() ? 'Discard changes' : 'Change address'}}
          </a>
          }
        </div>
        <div class="col-lg-6 col-md-12">
          <div class="form-floating">
            <input class="form-control" id="additionalAddress" placeholder formControlName="additional">
            <label for="additionalAddress">Additional address</label>
          </div>
        </div>
        <div class="col-lg-4 col-md-12">
          <div class="form-floating has-validation">
            <input class="form-control" [class.is-invalid]="validateErrors('city')" id="city" placeholder
              formControlName="city">
            <label for="city">City</label>
            <div *ngIf="validateErrors('address.city')" class="invalid-feedback">
              <i class="fas fa-xmark"></i>
              {{validateErrors('address.city')}}
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-12">
          <div class="form-floating has-validation">
            <input class="form-control" [class.is-invalid]="validateErrors('state')" id="state" placeholder
              formControlName="state">
            <label for="state">State</label>
            <div *ngIf="validateErrors('address.state')" class="invalid-feedback">
              <i class="fas fa-xmark"></i>
              {{validateErrors('address.state')}}
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-12">
          <div class="form-floating has-validation">
            <input class="form-control" [class.is-invalid]="validateErrors('state')" id="zipCode" placeholder
              formControlName="zipCode">
            <label for="zipCode">Zip code</label>
            <div *ngIf="validateErrors('address.zipCode')" class="invalid-feedback">
              <i class="fas fa-xmark"></i>
              {{validateErrors('address.zipCode')}}
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="form-floating">
            <input class="form-control" placeholder id="deliveryNotes" style="height: 100px"
              formControlName="deliveryNotes" />
            <label for="deliveryNotes">Delivery notes</label>
          </div>
        </div>
        <!-- Delivery window information -->
        @if (isUpdatingAddress() && deliveryOptions.length) {
        <div class="col mb-lg-5 mb-md-0 mb-sm-0">
          <h3>When should we deliver your order?</h3>
          <mat-form-field class="w-100 mb-0" [class.option-selected]="!!selectedDeliveryDay()">
            <mat-label>Choose a day*</mat-label>
            <mat-select name="selectedDeliveryDay" [value]="selectedDeliveryDay()?.id || null"
              (selectionChange)="setSelectedDeliveryDay($event)">
              @for (item of deliveryOptions; track $index) {
              <mat-option [value]="item.id">{{item.name}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (!selectedDeliveryDay()?.id) {
          <mat-error class="invalid-feedback animated fadeInDown">
            <i class="fas fa-xmark"></i>
            This field is required
          </mat-error>
          }
        </div>
        @if (selectedDeliveryDay()) {
        <div class="col align-items-end d-flex col mb-5">
          @if (selectedDeliveryDay()?.allowTimeWindow) {
          <div class="w-100 position-relative">
            <mat-form-field class="w-100 animated fadeInLeft mb-0"
              [class.option-selected]="!!selectedDeliveryTimeWindow()">
              <mat-label>Choose a time window*</mat-label>
              <mat-select name="selectedDeliveryTimeWindow" [value]="selectedDeliveryTimeWindow() || null"
                (selectionChange)="selectedDeliveryTimeWindow.set($event.value)">
                @for (item of timeSet(); track $index) {
                <mat-option [value]="item.id">{{item.name}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            @if (!selectedDeliveryTimeWindow()) {
            <mat-error class="invalid-feedback position-absolute animated fadeInLeft">
              <i class="fas fa-xmark"></i>
              This field is required
            </mat-error>
            }
          </div>
          }
          @else {
          <mat-form-field class="w-100 animated fadeInLeft">
            <mat-label>Time window *</mat-label>
            <input type="text" matInput readonly="true" name="selectedDeliveryTimeWindow"
              [value]="selectedDeliveryDay()?.timeSet?.[0]?.name">
          </mat-form-field>
          }
        </div>
        }
        }
      </div>
    </div>

    <div class="row form-row" action="" class="form" formGroupName="settings">
      <div class="col-md-6">
        <div class="form-floating">
          <mat-checkbox formControlName="receiveText">Yes, send me text message updates about my order</mat-checkbox>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-floating">
          <mat-checkbox formControlName="receiveNewsletter">
            Yes, send emails about local products and producers.
          </mat-checkbox>
        </div>
      </div>
    </div>

    <div class="d-grid col-lg-3 col-md-12 mx-auto mt-5">
      <button type="button" class="btn btn-primary" (click)="saveChanges($event)"
        [disabled]="disableSubmitButton()">{{submitButtonText()}}</button>
    </div>

  </form>


</div>